import { api } from './client.js'
import { endpoints } from './endpoints.js'
import { unwrapList } from '../utils/format.js'

/**
 * Radiology centre catalogue self-service API. Mirrors pharmacyStock /
 * laboratoryStock.
 */

export async function listRadiologyCentres() {
  const { data } = await api.get(endpoints.radiologyList)
  return unwrapList(data)
}

export async function listRadiologyStock({ centreId, search = '' } = {}) {
  const params = {}
  if (centreId) params.radiology_center = centreId
  if (search?.trim()) params.search = search.trim()
  const { data } = await api.get(endpoints.radiologyStock, { params })
  return unwrapList(data)
}

export async function downloadRadiologyTemplate({ modality = '' } = {}) {
  const params = {}
  if (modality) params.modality = modality
  const res = await api.get(endpoints.radiologyStockTemplate, { params, responseType: 'blob' })
  return res.data
}

export async function bulkUploadRadiology({ file, centreId }) {
  const fd = new FormData()
  fd.append('file', file)
  fd.append('radiology_center_id', String(centreId))
  const { data } = await api.post(endpoints.radiologyStockBulkUpload, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data
}

export async function updateRadiologyStockRow(id, patch) {
  const { data } = await api.patch(`${endpoints.radiologyStock}${id}/`, patch)
  return data
}

export async function deleteRadiologyStockRow(id) {
  await api.delete(`${endpoints.radiologyStock}${id}/`)
}

/**
 * Upload (or replace) the illustrative image for a *global* ImagingStudy.
 * Admin-only on the ImagingStudyViewSet. Radiology staff see the image
 * via the read-only `study_image_url` pass-through on RadiologyStockSerializer.
 */
export async function setImagingStudyImage(studyId, file) {
  const fd = new FormData()
  if (file) {
    fd.append('image', file)
  } else {
    fd.append('image', '')
  }
  const { data } = await api.patch(
    `${endpoints.imagingStudySearch}${studyId}/`,
    fd,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  )
  return data
}
